module.exports = __webpack_public_path__ + "img/hardySpine1.b54df2ab.png";